<template>
  
  <search-picker 
    ref="searchPicker"
    path="customers" 
    attributes="id,shortName,city,state"
    :authToken="authToken"
    :fluid="fluid"
    :renderTitle="renderTitle"
    :renderDescription="renderDescription"
    @onClear="$emit('onClear')" 
    @onPick="onPick" 
  />

</template>

<script>

  import SearchPicker from "./search-picker"

  export default {

    name: "CustomerPicker",

    props: {
      authToken: { type: String },
      fluid: { type: Boolean, default: true },      
    },
    
    components: {
      SearchPicker,
    },  

    methods: {

      renderTitle(customer) {
        return customer.shortName
      },

      renderDescription(customer) {
        
        if (!customer.city)
          return ""
         
        return `<div class="m-t-10"><i class="map marker alternate blue icon"></i> ${customer.city.trim() + " / " + customer.state}</div>`
      },

      clear() {
        this.$refs.searchPicker.clear()
      },      

      onPick(customer) {
        this.$emit("onPick", customer)
      },

      setSelected(customer) {
        this.$refs.searchPicker.setSelected(customer)
      },
    },
  }

</script>